import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { Button } from "components";
import PropTypes from "prop-types";
import React from "react";

const theme = createTheme({
  overrides: {
    MuiInputBase: {
      root: {
        backgroundColor: "#ffffff94",
        fontSize: "small  !important"
      }
    },
    MuiAutocomplete: {
      inputRoot: {
        padding: "0px !important"
      },
      popper: {},
      option: {
        fontSize: "small  !important"
      }
    },
    PrivateNotchedOutline: {
      legendLabelled: {},
      legendNotched: {
        maxWidth: "0px !important"
      }
    }
  }
});

export default function CustomDialog(props) {
  const { id, open, fullWidth, maxWidth, title, children, onClose, botones } = props;

  return (
    <MuiThemeProvider theme={theme}>
      <Dialog
        id={id}
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        open={open}
        onClose={() => onClose()}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">{title}</DialogTitle>
        <DialogContent>{children}</DialogContent>
        <DialogActions>
          {botones}
          <Button onClick={onClose} color="rose"> Cerrar </Button>
        </DialogActions>
      </Dialog>
    </MuiThemeProvider>
  );
}

CustomDialog.propTypes = {
  children: PropTypes.node,
  botones: PropTypes.node,
  id: PropTypes.string,
  title: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  maxWidth: PropTypes.string
};
